import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { usePageData } from '../../pages/BookAppointment/context/PageDataContext.js';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';
import Layout from './Layout.js';

const LayoutContainer = (props)=>{
    const [_, { currentRoute  }] = useRoutingContext();
    const { campaignInfoBanner  } = usePageData();
    React.useEffect(()=>{
        /** If already at the top of the page should trigger scroll event
     * if client side routing changed to show the header. */ if (window.scrollY === 0) {
            window.dispatchEvent(new CustomEvent('scroll'));
        } else {
            window.scrollTo(0, 0);
        }
    }, [
        currentRoute
    ]);
    return /*#__PURE__*/ React.createElement(Layout, swcHelpers.extends({}, props, {
        banner: campaignInfoBanner,
        hasNavigation: currentRoute !== 'confirmation',
        resetHtmlScrolling: ![
            '',
            'where'
        ].includes(currentRoute)
    }));
};

export { LayoutContainer as default };
//# sourceMappingURL=LayoutContainer.js.map
